export interface AffiliateProduct {
  id: string;
  name: string;
  shortName: string;
  description: string;
  category: 'eye-mask' | 'headphones' | 'earbuds';
  asin: string;
}

const affiliateLinksFlag = import.meta.env.VITE_AFFILIATE_LINKS;
// Affiliate links are enabled by default in production unless explicitly disabled.
export const AFFILIATE_LINKS_ENABLED = import.meta.env.PROD
  ? affiliateLinksFlag !== 'false'
  : affiliateLinksFlag === 'true';
// TODO: Update affiliate tag once new Amazon Associates tag is registered (https://github.com/delikat/ketaflow/issues/67)
export const AFFILIATE_TAG = import.meta.env.VITE_AFFILIATE_TAG || 'ketaflow-20';

export const affiliateProducts: AffiliateProduct[] = [
  {
    id: 'mindfold-mask',
    name: 'Dream Essentials Mindfold Sleeping Mask',
    shortName: 'Mindfold Eye Mask',
    description: 'Total darkness for deep inner focus',
    category: 'eye-mask',
    asin: 'B00011R3N0',
  },
  {
    id: 'airpods-pro',
    name: 'Apple AirPods Pro',
    shortName: 'AirPods Pro',
    description: 'Premium noise cancellation',
    category: 'earbuds',
    asin: 'B0FQFB8FMG',
  },
  {
    id: 'anker-life-q20',
    name: 'Soundcore Anker Life Q20',
    shortName: 'Anker Life Q20',
    description: 'Budget over-ear with ANC',
    category: 'headphones',
    asin: 'B0DLKB5V35',
  },
  {
    id: 'anker-space-a40',
    name: 'Soundcore Anker Space A40',
    shortName: 'Anker Space A40',
    description: 'Budget earbuds with ANC',
    category: 'earbuds',
    asin: 'B0B1LVC5VZ',
  },
];

export function getAffiliateUrl(asin: string): string {
  return `https://www.amazon.com/dp/${asin}?tag=${AFFILIATE_TAG}`;
}

export function getProductsByCategory(category: AffiliateProduct['category']): AffiliateProduct[] {
  return affiliateProducts.filter(p => p.category === category);
}
